"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _BreadcrumbsModule = _interopRequireDefault(require("./Breadcrumbs.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const BreadcrumbSeparator = () => /*#__PURE__*/React.createElement(_Icon.Icon, {
  className: _BreadcrumbsModule.default.separator,
  name: "chevron-right",
  size: "small",
  color: "secondary"
});
const Breadcrumbs = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    linkComponent
  } = _ref;
  const total = React.Children.count(children);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "Breadcrumbs",
    className: (0, _classify.default)(_BreadcrumbsModule.default.wrapper, classNames?.wrapper)
  }, React.Children.map(children, (child, idx) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(React.Fragment, {
    key: `crumb-${idx}`
  }, /*#__PURE__*/React.isValidElement(child) && child?.type?.displayName === 'BreadcrumbLink' ? /*#__PURE__*/React.cloneElement(child, {
    linkComponent
  }) : child, idx < total - 1 && /*#__PURE__*/React.createElement(BreadcrumbSeparator, {
    "aria-hidden": true
  }))));
});
exports.Breadcrumbs = Breadcrumbs;